module.exports = __webpack_public_path__ + "static/media/team-marcus.f64c8b7e.jpg";